module.exports = "<svg class=\"icon btn__icon\">\n\t<use xlink:href=\"#icon-delete_new\"/>\n</svg>";